const MATCH_FORMAT_VALUES = Object.freeze(['TRADITIONAL', 'PRO_SET_8'])

export const MATCH_FORMAT = Object.freeze({
  TRADITIONAL: MATCH_FORMAT_VALUES[0],
  PRO_SET_8: MATCH_FORMAT_VALUES[1],
})

export function normalizeMatchFormat(matchFormat) {
  if (matchFormat === MATCH_FORMAT.PRO_SET_8) {
    return MATCH_FORMAT.PRO_SET_8
  }
  return MATCH_FORMAT.TRADITIONAL
}

export const VALID_MATCH_FORMATS = MATCH_FORMAT_VALUES
